import Vue from 'vue';

import {store} from './store';
import {router} from './routes';
import {mapActions, mapGetters} from 'vuex';
import setupVue2TouchEvents from "@/plugins/touch-events"

import VueResource from 'vue-resource';
Vue.use(VueResource);
Vue.http.options.root = '/api';

import PortalVue from 'portal-vue'
Vue.use(PortalVue)

import VueAwesomeSwiper from 'vue-awesome-swiper';
Vue.use(VueAwesomeSwiper /* { default global options } */);

setupVue2TouchEvents(Vue)

import MaskedInput from 'vue-masked-input';
Vue.component('masked-input', MaskedInput);

// v-parallax="0.2"
import VueParallaxJs from 'vue-parallax-js';
Vue.use(VueParallaxJs);

import onScrollAnimate from '@assets/js/scrollAnimate.js';

import VueCookie from 'vue-cookie';
Vue.use(VueCookie);

// Директива v-click-outsid собитые при клике вне элемента
import vClickOutside from 'v-click-outside';
Vue.use(vClickOutside);

// для календаря на странице мероприятий
import Vuetify from '@assets/js/vuetify.js';
// import Vuetify from "vuetify";
Vue.use(Vuetify);

import {VueMasonryPlugin} from 'vue-masonry';
Vue.use(VueMasonryPlugin);

import YmapPlugin from 'vue-yandex-maps';
Vue.use(YmapPlugin);

// import VCalendar from 'v-calendar';
// Vue.use(VCalendar);

// import Multiselect from 'vue-multiselect';
// Vue.use(Multiselect);
// Vue.component('vue-multiselect', window.VueMultiselect.default);

// Директива v-lazy для отложенной загрузки изображений
// import VueLazyload from 'vue-lazyload'
// Vue.use(VueLazyload);
// или подключение с опциями
// Vue.use(VueLazyload, {
//   preLoad: 1.3,
//   error: 'dist/error.png',
//   loading: 'dist/loading.gif',
//   attempt: 1
// })

// Директива v-clampy="3" обрезает содержимое внутри элемента и добавляет многоточие в конец
// с этой директивой не обновляються данные в шаблоне твига при routeUpdate
// import clampy from '@clampy-js/vue-clampy';
// Vue.use(clampy);

import Header from '@components/base/header/component.js';
import Footer from '@components/base/footer/component.js';
import Curtain from '@components/base/curtain/component.js';
import Modal from '@components/base/modal.vue';
import Breadcrumbs from '@components/ui-components/breadcrumbs/component.js';
import Popular from '@components/ui-components/popular/component.js';
import Share from '@components/ui-components/share/component.js';

// import Banner from '@components/ui-components/banner/component.js';

import {mapState, mapMutations} from 'vuex';

Vue.component('curtain-cmp', Curtain);
Vue.component('popular-cmp', Popular);
Vue.component('share-cmp', Share);
Vue.component('breadcrumbs-cmp', Breadcrumbs);
// Vue.component('banner-cmp', Banner);

Vue.directive('animation', {
    // Когда привязанный элемент вставлен в DOM...
    bind: function (el, binding, vnode) {
        el.dataset.animate = false;
        if (binding.arg) {
            el.dataset.animateDirection = binding.arg;
        }
        if (binding.modifiers) {
            for (var mod in binding.modifiers) {
                el.dataset[mod] = binding.modifiers[mod];
            }
        }
    },
});

// Директива v-link вместо элемента router-link
Vue.directive('link', {
    // Когда привязанный элемент вставлен в DOM...
    bind(el) {
        const href = el.getAttribute('href');
        // если ссылка внутренняя, то добавляем базовый язык впереди ссылки
        if (href.charAt(0) === '/') {
            el.setAttribute('href', router.history.base + href);
        }

        el.addEventListener('click', (e) => linkAction(e, el));
    },
    unbind(el) {
        el.removeEventListener('click', (e) => linkAction(e, el));
    },
});

let responseDone = true;
router.beforeEach((to, from, next) => {
    window.removeEventListener('scroll', onScrollAnimate);
    let hideBeforeRouteElements = document.querySelectorAll('.hide-before-route');
    hideBeforeRouteElements.forEach((el) => el.classList.add('hiddenForRoute'));

    if (store.state.mobile.isMobileMenuVisible) {
        store.commit('mobile/setHiddenMobileMenu');
    }
    if (store.state.mobile.isTabletMenuVisible) {
        store.commit('mobile/setHiddenTabletMenu');
    }

    store.dispatch('locale/LoadLocale').then(
        () => {
            // если хотим перейти на страницу для которой нужна авторизация (страница лк),
            // то делаем запрос на уведомления
            // и проверяем получен ли ответ на предыдущий запрос уведомлений
            if (to.matched.some(record => record.meta.requiresAuth) && responseDone) {
                responseDone = false;
                store.dispatch('lk/getNotification').then((data) => {
                    responseDone = true;
                });
            }
            next();
        },
        (newPath) => {
            if (to.matched.some(record => record.meta.requiresAuth)) {
                responseDone = false;
                store.dispatch('lk/getNotification').then(() => {
                    responseDone = true;
                });
            }
            next(newPath);
        }
    );
});

router.afterEach((to, from) => {
    // topScrollNone используем в routes.js для страниц дочерних например, когда скролл наверх не нужен
    if (
        to.path !== from.path &&
        (!to.matched.some((record) => record.meta.topScrollNone) ||
            !from.matched.some((record) => record.meta.topScrollNone))
    ) {

        if (to.fullPath.includes('#')) {
            console.log(from)
            setTimeout(() => {
                let selector = '[data-anchor="' + to.hash.split('#')[1] + '"]'
                let elem = document.querySelector(selector);
                if (elem) {
                    let animationOffset = elem.getAttribute('data-animate') === 'false' ? 50 : 0;
                    let top = elem.getBoundingClientRect().top + window.pageYOffset -
                        document.querySelector('header').clientHeight - animationOffset;
                    window.scrollTo({
                        top: top,
                        behavior: 'smooth',
                    });
                } 

            }, 1200);   
        } else {
            // скролл наверх страницы
            setTimeout(() => {
                window.scrollTo({
                    top: 0,
                    behavior: 'instant',
                });
            }, 750);
        }

        // закрываем модалку
        store.commit('modal/modalClose');

        store.dispatch('meta/loadItems', to.path).then(() => {
            meta(store);
        });
    }


    setTimeout(() => {
        onScrollAnimate();
        window.addEventListener('scroll', onScrollAnimate);
    }, 1100);

    setTimeout(() => {
        store.commit('lk/updateRefererLinkAuth');
        store.commit('lk/updateRefererLinkLogout');
        store.commit('curtain/Show');
        window.content = undefined;
    }, 600);
});

// обновляем профиль и переменную isAuth
if (window.lk.profile && window.lk.profile.id) {
    store.commit('lk/logIn');
    store.commit('lk/setProfile', window.lk.profile);
} else {
    store.commit('lk/logOut');
}

new Vue({
    el: '#app',
    store,
    router,
    vuetify: new Vuetify(),
    components: {
        'header-cmp': Header,
        'footer-cmp': Footer,
        'modal-cmp': Modal,
    },
    data() {
        return {
            mountPage: false,
            staticText: undefined,
            // personalLink: undefined,
            optionsTheme: undefined,
            lk: undefined,

            linkRegistration: undefined,
            linkB2bPlatform: undefined,

            visibleModal: false,
            visibleMsgCookies: false,
            currentYear: undefined,
            minHeight: null,

            loadVue: false,
            sitekeyRecaptcha: null,
            siteDadataKey: null,
            siteDadataSecret: null,

            __AXOFT__: null
        };
    },
    computed: {
        ...mapState('mobile', ['isMobileMenuVisible', 'isTabletMenuVisible', 'isMobile', 'isTablet']),
        ...mapGetters({
            isPortalOpened: 'portal/getIsOpened',
            modalState: 'modal/modalState'
        }),
        pageClass() {
            return 't-page_' + this.$route.name;
        },
        isMain() {
            return this.$route.name === 'main'
        }
    },
    watch: {
        isMobileMenuVisible() {
            if (this.isMobileMenuVisible) {
                this.disableScroll();
            } else {
                this.enableScroll();
            }
        },
        isTabletMenuVisible() {
            if (this.isTabletMenuVisible) {
                this.disableScroll();
            } else {
                this.enableScroll();
            }
        },
        modalState() {
            if (this.modalState) {
                this.disableScroll();
            } else {
                this.enableScroll();
            }
        },
        isPortalOpened(isOpened) {
            isOpened
                ? this.disableScroll()
                : this.enableScroll();
        }
    },
    methods: {
        ...mapMutations('mobile', ['setHiddenMobileMenu', 'setTabletState', 'setMobileState', 'setTabletHeaderState']),
        ...mapMutations('lk', ['setLinkAuth', 'setLinkLogout']),

        disableScroll() {
            // if (this.isTablet || this.isMobile) {
            let body = document.querySelector('body');
            if (body.style.position !== "fixed") {
                let heightScroll = window.pageYOffset;
                body.style.cssText = "top: " + (-heightScroll) + "px; position: fixed;";
            }
        },
        enableScroll() {
            // if (this.isTablet || this.isMobile) {
            let body = document.querySelector('body');
            let heightTop = body.style.top;

            if (heightTop) {
                body.style.cssText = "top: auto; position: static;";
                window.scrollTo({
                    top: -parseInt(heightTop),
                    behavior: "instant"
                });
            }
        },
        num2str(n, text_forms) {
            n = Math.abs(n) % 100;
            let n1 = n % 10;
            if (n > 10 && n < 20) {
                return text_forms[2];
            }
            if (n1 > 1 && n1 < 5) {
                return text_forms[1];
            }
            if (n1 === 1) {
                return text_forms[0];
            }
            return text_forms[2];
        },
        setDataAnimateFalse(selector = '') {
            document.querySelectorAll(selector + '[data-animate="true"]').forEach((item) => {
                item.setAttribute('data-animate', false);
                item.setAttribute('data-delay', true);
            });
        },
        closeCookies() {
            localStorage.setItem('visibleMsgCookies', 'false');
            this.visibleMsgCookies = false;
        },
        scrollToBlock(selector) {
            let elem = document.querySelector(selector);
            if (elem) {
                let animationOffset = elem.getAttribute('data-animate') === 'false' ? 50 : 0;
                let top = elem.getBoundingClientRect().top + window.pageYOffset -
                    document.querySelector('header').clientHeight - animationOffset;
                window.scrollTo({
                    top: top,
                    behavior: 'smooth',
                });
            }
        },
        socialIcon(id) {
            switch (parseInt(id)) {
                case 1:
                    return '<svg width="11" height="22" viewBox="0 0 11 22" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M6.75129 21.7596V10.8785H9.75494L10.153 7.12884H6.75129L6.7564 5.25209C6.7564 4.27412 6.84932 3.7501 8.25397 3.7501H10.1317V0H7.12765C3.51928 0 2.24923 1.81899 2.24923 4.87797V7.12926H0V10.8789H2.24923V21.7596H6.75129Z" fill="#E0E1E2"/></svg>';
                case 2:
                    return '<svg width="22" height="12" viewBox="0 0 22 12" fill="none" xmlns="http://www.w3.org/2000/svg"> <path fill-rule="evenodd" clip-rule="evenodd" d="M11.7129 11.8967C11.7129 11.8967 12.0979 11.8547 12.2951 11.6468C12.4756 11.4563 12.4694 11.0968 12.4694 11.0968C12.4694 11.0968 12.4454 9.41814 13.2394 9.17028C14.022 8.92652 15.0268 10.7937 16.0931 11.5116C16.8987 12.0545 17.5101 11.9357 17.5101 11.9357L20.3597 11.8967C20.3597 11.8967 21.8497 11.8066 21.1433 10.6564C21.0848 10.5622 20.7311 9.80529 19.0251 8.25054C17.2378 6.62307 17.4777 6.88629 19.6293 4.07073C20.9398 2.3562 21.4636 1.30946 21.2998 0.861876C21.1443 0.433756 20.1802 0.547443 20.1802 0.547443L16.9727 0.566903C16.9727 0.566903 16.7348 0.535153 16.5585 0.638598C16.3863 0.739995 16.2747 0.976588 16.2747 0.976588C16.2747 0.976588 15.7676 2.30294 15.0904 3.43162C13.662 5.81189 13.0912 5.93787 12.8575 5.79038C12.3139 5.44522 12.4495 4.40565 12.4495 3.66719C12.4495 1.35964 12.8064 0.397908 11.7557 0.149025C11.4072 0.0660637 11.1505 0.0117805 10.2584 0.00256261C9.11374 -0.00870372 8.14545 0.00665945 7.59662 0.269882C7.23142 0.445022 6.9497 0.836271 7.12186 0.858804C7.33368 0.886457 7.81365 0.985806 8.06824 1.32584C8.39692 1.76523 8.38544 2.75052 8.38544 2.75052C8.38544 2.75052 8.5743 5.46673 7.94407 5.8037C7.5121 6.03517 6.91944 5.56301 5.64543 3.40295C4.9933 2.2968 4.50081 1.07389 4.50081 1.07389C4.50081 1.07389 4.40586 0.845489 4.23578 0.722583C4.03023 0.574073 3.74329 0.527983 3.74329 0.527983L0.695476 0.547443C0.695476 0.547443 0.237417 0.559734 0.0694271 0.755358C-0.0797812 0.92845 0.0579495 1.28795 0.0579495 1.28795C0.0579495 1.28795 2.44424 6.76851 5.14668 9.5308C7.62479 12.0627 10.4378 11.8967 10.4378 11.8967H11.7129Z" fill="#E0E1E2"/> </svg>';
                case 3:
                    return '<svg width="20" height="16" viewBox="0 0 20 16" fill="none" xmlns="http://www.w3.org/2000/svg"> <path fill-rule="evenodd" clip-rule="evenodd" d="M9.401 4.25625L9.44297 4.9483L8.74349 4.86356C6.19739 4.53872 3.97304 3.4371 2.08445 1.58693L1.16114 0.668915L0.923313 1.34684C0.419688 2.85804 0.741448 4.45398 1.79067 5.52735C2.35025 6.12054 2.22434 6.20528 1.25906 5.85219C0.923313 5.7392 0.629531 5.65446 0.601552 5.69683C0.503625 5.7957 0.839375 7.08092 1.10518 7.58937C1.46891 8.29554 2.21035 8.98758 3.02175 9.39716L3.70724 9.722L2.89584 9.73612C2.11243 9.73612 2.08445 9.75024 2.16839 10.0468C2.44818 10.9649 3.55335 11.9394 4.78444 12.3631L5.65179 12.6597L4.89636 13.1116C3.77719 13.7613 2.46217 14.1285 1.14715 14.1567C0.517615 14.1709 0 14.2274 0 14.2697C0 14.411 1.70673 15.2019 2.69999 15.5126C5.67977 16.4306 9.21914 16.0351 11.8772 14.4674C13.7658 13.3517 15.6543 11.1343 16.5357 8.98758C17.0113 7.84359 17.487 5.75333 17.487 4.75057C17.487 4.10089 17.529 4.01615 18.3124 3.23937C18.774 2.78742 19.2077 2.2931 19.2916 2.15187C19.4315 1.88352 19.4175 1.88352 18.7041 2.12362C17.515 2.54732 17.3471 2.49083 17.9346 1.85528C18.3683 1.40333 18.8859 0.584174 18.8859 0.344077C18.8859 0.301707 18.6761 0.372324 18.4383 0.499434C18.1865 0.640668 17.6269 0.852518 17.2072 0.979629L16.4518 1.21973L15.7663 0.753655C15.3885 0.499434 14.8569 0.216967 14.5771 0.132227C13.8637 -0.0655007 12.7725 -0.0372539 12.129 0.18872C10.3803 0.824272 9.27509 2.46258 9.401 4.25625Z" fill="#E0E1E2"/> </svg>';
                case 4:
                    return '<svg width="22" height="21" viewBox="0 0 22 21" fill="none" xmlns="http://www.w3.org/2000/svg"> <path fill-rule="evenodd" clip-rule="evenodd" d="M5.09897 2.35225C5.06955 1.017 4.11471 0 2.56419 0C1.01368 0 0 1.017 0 2.35225C0 3.65984 0.983715 4.70612 2.50536 4.70612H2.53432C4.11471 4.70612 5.09897 3.65984 5.09897 2.35225ZM4.80197 6.56494H0.269531V20.183H4.80197V6.56494ZM15.9276 6.2451C18.9101 6.2451 21.1461 8.19188 21.1461 12.3748L21.146 20.183H16.6137V12.8973C16.6137 11.0673 15.9578 9.81853 14.3171 9.81853C13.0649 9.81853 12.319 10.6604 11.9915 11.4735C11.8716 11.7649 11.8422 12.1709 11.8422 12.5779V20.1833H7.30923C7.30923 20.1833 7.36897 7.84309 7.30923 6.56524H11.8422V8.49413C12.4438 7.56687 13.5212 6.2451 15.9276 6.2451Z" fill="#E0E1E2"/> </svg>';
                case 5:
                    return '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"> <path fill-rule="evenodd" clip-rule="evenodd" d="M12.001 0C8.742 0 8.333 0.01425 7.053 0.0725C5.7755 0.131 4.9035 0.33325 4.1405 0.63C3.35125 0.9365 2.68175 1.3465 2.01475 2.01375C1.34725 2.68075 0.93725 3.35025 0.62975 4.13925C0.33225 4.9025 0.12975 5.77475 0.07225 7.05175C0.015 8.33175 0 8.741 0 12C0 15.259 0.0145 15.6668 0.0725 16.9468C0.13125 18.2243 0.3335 19.0963 0.63 19.8593C0.93675 20.6485 1.34675 21.318 2.014 21.985C2.68075 22.6525 3.35025 23.0635 4.139 23.37C4.9025 23.6668 5.77475 23.869 7.052 23.9275C8.332 23.9858 8.74075 24 11.9995 24C15.2588 24 15.6665 23.9858 16.9465 23.9275C18.224 23.869 19.097 23.6668 19.8605 23.37C20.6495 23.0635 21.318 22.6525 21.9848 21.985C22.6523 21.318 23.0623 20.6485 23.3698 19.8595C23.6648 19.0963 23.8673 18.224 23.9273 16.947C23.9848 15.667 23.9998 15.259 23.9998 12C23.9998 8.741 23.9848 8.332 23.9273 7.052C23.8673 5.7745 23.6648 4.9025 23.3698 4.1395C23.0623 3.35025 22.6523 2.68075 21.9848 2.01375C21.3173 1.34625 20.6498 0.93625 19.8598 0.63C19.0948 0.33325 18.2223 0.131 16.9448 0.0725C15.6648 0.01425 15.2573 0 11.9973 0H12.001ZM10.9253 2.16248C11.2448 2.16198 11.6013 2.16248 12.0018 2.16248C15.2058 2.16248 15.5855 2.17398 16.8508 2.23148C18.0208 2.28498 18.6558 2.48048 19.0788 2.64473C19.6388 2.86223 20.038 3.12223 20.4578 3.54223C20.8778 3.96223 21.1378 4.36223 21.3558 4.92223C21.52 5.34473 21.7158 5.97973 21.769 7.14973C21.8265 8.41473 21.839 8.79473 21.839 11.9972C21.839 15.1997 21.8265 15.5797 21.769 16.8447C21.7155 18.0147 21.52 18.6497 21.3558 19.0722C21.1383 19.6322 20.8778 20.031 20.4578 20.4507C20.0378 20.8707 19.639 21.1307 19.0788 21.3482C18.6563 21.5132 18.0208 21.7082 16.8508 21.7617C15.5858 21.8192 15.2058 21.8317 12.0018 21.8317C8.79753 21.8317 8.41778 21.8192 7.15278 21.7617C5.98278 21.7077 5.34778 21.5122 4.92453 21.348C4.36453 21.1305 3.96453 20.8705 3.54453 20.4505C3.12453 20.0305 2.86453 19.6315 2.64653 19.0712C2.48228 18.6487 2.28653 18.0137 2.23328 16.8437C2.17578 15.5787 2.16428 15.1987 2.16428 11.9942C2.16428 8.78973 2.17578 8.41173 2.23328 7.14673C2.28678 5.97673 2.48228 5.34173 2.64653 4.91873C2.86403 4.35873 3.12453 3.95873 3.54453 3.53873C3.96453 3.11873 4.36453 2.85873 4.92453 2.64073C5.34753 2.47573 5.98278 2.28073 7.15278 2.22698C8.25978 2.17698 8.68878 2.16198 10.9253 2.15948V2.16248ZM18.4055 4.15501C17.6105 4.15501 16.9655 4.79926 16.9655 5.59451C16.9655 6.38951 17.6105 7.03451 18.4055 7.03451C19.2005 7.03451 19.8455 6.38951 19.8455 5.59451C19.8455 4.79951 19.2005 4.15451 18.4055 4.15451V4.15501ZM12.0017 5.83746C8.59842 5.83746 5.83917 8.59671 5.83917 12C5.83917 15.4032 8.59842 18.1612 12.0017 18.1612C15.4049 18.1612 18.1632 15.4032 18.1632 12C18.1632 8.59671 15.4047 5.83746 12.0014 5.83746H12.0017ZM12.0007 8.00002C14.2097 8.00002 16.0007 9.79077 16.0007 12C16.0007 14.209 14.2097 16 12.0007 16C9.79146 16 8.00071 14.209 8.00071 12C8.00071 9.79077 9.79146 8.00002 12.0007 8.00002Z" fill="#DADADA"/> </svg>';
            }
        },
        convertTwigToJs(data, classData) {
            if (document.querySelector(classData)) {
                let dataEvents = document.querySelector(classData).getAttribute('data-' + data);
                dataEvents = dataEvents.replace(/'/g, '"');
                return JSON.parse(dataEvents);
            }
        },
        clickBtn(link) {
            if (link.includes('#')) {
                this.scrollToBlock('[data-anchor="' + link.split('#')[1] + '"]');
            } else {
                if (link.includes('http://') || link.includes('https://')) {
                    window.open(link, '_blank');
                } else {
                    this.$router.push(link);
                }
            }
        },
    },
    created() {
        // определение переменных мобильной версии и планшета
        this.setMobileState(isMobile());
        this.setTabletState(isTablet());
        this.setTabletHeaderState(isTabletHeader());

        // переопределение при изменнении ширины экрана
        window.addEventListener('resize', () => {
            this.setMobileState(isMobile());
            this.setTabletState(isTablet());
            this.setTabletHeaderState(isTabletHeader());    
        });

        // текст переводов для мультиязычных версий сайтов (используется для js шаблонов)
        this.staticText = window.staticText;
        // this.personalLink = window.personalLink;
        this.optionsTheme = window.optionsTheme;
        this.lk = window.lk;

        this.setLinkAuth(window.linkAuth);
        this.linkRegistration = window.linkRegistration;
        this.setLinkLogout(window.linkLogout);
        this.linkB2bPlatform = window.linkB2bPlatform;

        this.sitekeyRecaptcha = window.sitekeyRecaptcha;
        this.siteDadataKey = window.siteDadataKey;
        this.siteDadataSecret = window.siteDadataSecret;

        this.__AXOFT__ = window.__AXOFT__

        // расчет текущего года для футера
        let date = new Date();
        this.currentYear = date.getFullYear();
    },
    beforeMount() {
        let content = document.getElementById('content');
        window.content = content.innerHTML;

        if (typeof content.remove == 'function') {
            //If support  is found
            content.remove();
        } else {
            //If not
            content.outerHTML = '';
        }
    },
    mounted() {
        this.loadVue = true;
        setTimeout(() => {
            const footerHeight = document.querySelector('footer') ? document.querySelector('footer').clientHeight : 0;
            this.minHeight = `calc(100vh + ${footerHeight}px)`;
        }, 500);
        localStorage.getItem('visibleMsgCookies') === 'false'
            ? (this.visibleMsgCookies = false)
            : (this.visibleMsgCookies = true);
    },
});

function isTabletHeader() {
    return window.innerWidth > 920 && window.innerWidth < 1280;
}

function isTablet() {
    return window.innerWidth > 920 && window.innerWidth < 1161;
}

function isMobile() {
    return window.innerWidth < 921;
}

// переход по ссылке
function linkAction(e, item) {
    e.preventDefault();
    if (item.getAttribute('to')) {
        router.push(item.getAttribute('to')).catch(() => {});
    } else {
        const path = item.getAttribute('href');
        if (path.charAt(0) === '/') {
            if (router.currentRoute.path !== path) {
                router
                    .push(path.replace(router.history.base, ''))
                    .catch(() => {});
            }
        } else {
            window.open(item.href, '_blank').focus();
        }
    }
}

const meta = (store) => {
    let head = document.head;

    let items = store.getters['meta/items'];
    Object.keys(items).forEach((item) => {
        if (item === 'title') document.title = items.title;

        if (item === 'keywords') {
            let keywords = head.querySelector('meta[name="keywords"]');
            if (!keywords) {
                keywords = document.createElement('meta');
                keywords.setAttribute('name', 'Keywords');
                head.appendChild(keywords);
            }
            keywords.setAttribute('content', items.keywords);
        }
        if (item === 'description') {
            let description = head.querySelector('meta[name="description"]');
            if (!description) {
                description = document.createElement('meta');
                description.setAttribute('name', 'description');
                head.appendChild(description);
            }
            description.setAttribute('content', items.description);
        }
    });
};



// WEBPACK FOOTER //
// ./src/main.js